import { ResourceCountry } from '../models/resources/resources.model';

export class PhoneNumberHelper {

  static readonly countryCodeValidator = /^\s*\+?[\d\s]+$/;
  static readonly phoneValidator = /^[-\d\s+]*$/;

  static getSplitPhoneNumber(phone: string | null): { code: string; phone: string } {
    phone = phone?.trim() ?? '';

    let result: { code: string; phone: string };

    if (phone.startsWith('+')) {
      if (phone.includes(' ')) {
        const splitPhone = phone.split(' ').filter(item => !!item);

        result = {
          code: splitPhone[0] ?? '',
          phone: splitPhone[1] ? splitPhone.slice(1).join(' ') : '',
        };
      } else {
        result = {
          code: phone.substr(0, 3),
          phone: phone.substr(3)
        };
      }
    } else {
      result = {
        code: '',
        phone
      };
    }

    result.code = result.code.replace('+', '');

    return result;
  }

  static getPhoneNumber(code: string, phone: string): string | null {
    code = code?.trim() ?? '';
    phone = phone?.trim() ?? '';

    if (!phone) {
      return null;
    }

    let result = (code + ' ' + phone).split(' ').filter(item => !!item && item !== '+').join(' ');
    result = result.replace(/\+/g, ' ');

    if (code && result) {
      result = '+' + result;
    }

    if (result) {
      result = result.replace(/\s*-\s*/g, '-');
      result = result.replace(/\s*\+\s*/g, '+');
    }

    return result ? (result) : null;
  }

  static getCodeList(countries: ResourceCountry[]): { code: string; name: string }[] {
    const codeMap: {[key: string]: boolean} = {};

    return countries
        .filter(country => {
          if (!country.PhonePrefix || codeMap[country.PhonePrefix]) {
            return false;
          }

          codeMap[country.PhonePrefix] = true;
          return true;
        }).map(country => ({ code: country.PhonePrefix, name: '+' + country.PhonePrefix }));
  }
}
